import { axiosInstance as request } from '@api/rest.service'

const api = '/imports/subscription-prices'

/**
 * @description GET /imports/subscription-prices/template?start_year={year}
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_PRICES_IMPORT_TEMPLATE = year => request.get(`${api}/template?start_year=${year}`)

/**
 * @description POST /imports/subscription-prices/parse
 * @returns {AxiosPromise<any>}
 */
export const PARSE_SUBSCRIPTION_PRICES_IMPORT = payload => request.post(`${api}/parse`, payload)

/**
 * @description PUT /imports/subscription-prices/preview/rows/{rowId}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_SUBSCRIPTION_PRICES_IMPORT_ROWS = (rowId, payload) =>
  request.put(`${api}/preview/rows/${rowId}`, payload)

/**
 * @description POST /imports/subscription-prices/process
 * @returns {AxiosPromise<any>}
 */
export const PROCESS_SUBSCRIPTION_PRICES_IMPORT = payload => request.post(`${api}/process`, payload)
